

const Loading = ()=>{

    return(
        <section className="section">
            <h4>Loading....</h4>
        </section>
    )
}


export default Loading